import { langId } from '../lang'
import { getCountryObject } from './env'

async function resqFetch(path, ...args) {
	if (!path.startsWith('/')) {
		throw new Error('path must start with /')
	}

	if (!window.API_URL) {
		throw new Error('API URL not defined')
	}

	let API_URL = window.API_URL

	if (API_URL.endsWith('/')) {
		throw new Error('API URL must not contain a trailing slash')
	}

	let url = API_URL + path

	return await window.fetch(url, ...args)
}

// In local environment, proxy is made to dev provider api
export async function getEnv() {
	let response = await resqFetch('/provider/env')
	return await response.json()
}

export async function checkProvider(data) {
	return await get('/provider/doesProviderExist', data)
}

export async function signUp(data) {
	data.resqLang = langId

	const headers = new Headers()
	headers.append('Content-Type', 'application/json')
	headers.append('Accept', 'application/json')

	let response = await resqFetch('/provider/signUp', {
		method: 'POST',
		headers,
		body: JSON.stringify(data),
	})

	return await handleResponse(response)
}

export async function signUpValidate(data) {
	data.resqLang = langId
	return handleResponse(await resqFetch('/provider/signUpValidate?' + encodeGetParams(data)))
}

export async function interestedPartner(country, city, email) {
	let data = {
		country,
		city,
		email,
		resqLang: langId,
	}
	const headers = new Headers()
	headers.append('Content-Type', 'application/json')
	headers.append('Accept', 'application/json')

	await resqFetch('/provider/interestedPartner', {
		method: 'POST',
		headers,
		body: JSON.stringify(data),
	})
}

function encodeGetParams(obj) {
	return Object.keys(obj)
		.map(k => encodeURIComponent(k) + '=' + encodeURIComponent(obj[k]))
		.join('&')
}

export async function isCityAvailable(country, city) {
	country = getCountryObject(country).id // convert short id to long id
	let data = {
		country,
		city,
		resqLang: langId,
	}

	return await get('/provider/isCityAvailable', data)
}

async function handleResponse(response) {
	if (response.ok) {
		return await response.json()
	} else {
		throw new Error(await response.text())
	}
}

export async function get(path, params = {}) {
	// Dev convenience and harmony with old getRequest()
	if (!path.startsWith('/')) {
		path = '/' + path
	}

	let hasParams = Object.keys(params).length
	let pathAndQuery = hasParams ? `${path}?${encodeGetParams(params)}` : path

	let response = await resqFetch(pathAndQuery)

	return await handleResponse(response)
}

export async function post(path, params = {}) {
	params // avoid lint error
	throw new Error('implement POST too')
}
